import React, {useRef} from 'react';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import SignatureCanvas from "react-signature-canvas";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 'xl',
    maxHeight: "90%",
    overflow: "auto",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
};

const SigPadModal = ({open, handleClose, getSignature}) => {
    const sigPadModalRef = useRef(null);

    const capture = (e) => {
        e.preventDefault();
        handleClose();
        const trimmedData = sigPadModalRef.current.getTrimmedCanvas().toDataURL('image/png');
        getSignature(trimmedData);
    }
    const clear = (e) => {
        e.preventDefault();
        sigPadModalRef.current.clear();
    }

    return (
        <Modal
            open={open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleClose()
                }
            }}

            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography component="h2">Signature Pad</Typography>
                <Box sx={{border: 1, borderColor: "primary.main", p: 1, mb: 1, mt: 1}}>
                    <SignatureCanvas
                        ref={sigPadModalRef}
                        penColor='black'
                        canvasProps={{
                            width: 350,
                            height: 250,
                            className: 'sigCanvas'
                        }}
                    />
                </Box>
                <Stack spacing={1}
                       direction="row"
                       divider={<Divider orientation="vertical" flexItem/>}>
                    <Button variant="contained" onClick={capture}>Capture and Close</Button>
                    <Button variant="outlined" onClick={clear} color="error">Clear</Button>
                    <Button variant="outlined" onClick={handleClose} color="warning">Close</Button>
                </Stack>
            </Box>
        </Modal>
    );
};

export default SigPadModal;